import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Typography } from "antd";
import React from "react";
import "./index.scss";

interface LoaderProps {
  isLoading: boolean;
  loadingMessage: string | null;
}

const Loader: React.FC<LoaderProps> = ({ isLoading, loadingMessage }) => {
  if (!isLoading) return null;
  return (
    <div className="loader_container">
      <Spin
        spinning={isLoading}
        indicator={<LoadingOutlined spin />}
        size="large"
        className="spinner"
      />
      <Typography.Text className="loading-message">
        {loadingMessage ? loadingMessage : "Please wait..."}
      </Typography.Text>
    </div>
  );
};

export default Loader;
